import React from "react";
import Top from '../Top'
import Footer from '../Footer'
import { Row, Col, Descriptions, Spin, Tabs, Table } from "antd";
import { ArrowLeftOutlined } from '@ant-design/icons';
import { connect } from "react-redux";
import actionWays from '../../../redux/actions';
import moment from 'moment';
const { TabPane } = Tabs;

class ContractInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            houseList: '',
            tenantList: '',
            contractList: '',
            billItemList: '',
            tenantLists: ''
        }
    }
    componentDidMount() {
        const { toson } = this.props
        let houseList = toson.contractInfos.houseList
        let tenantList = toson.contractInfos.tenant
        let contractList = toson.contractInfos.contract
        let billItemList = toson.contractInfos.billItemList
        let tenantLists = toson.contractInfos.tenantList
        this.setState({
            houseList: houseList,
            tenantList: tenantList,
            contractList: contractList,
            billItemList: billItemList,
            tenantLists: tenantLists,
        }, () => {
            this.setState({
                loading: false
            })
        })
    }
    render() {
        const { loading, houseList, tenantList, contractList, billItemList, tenantLists } = this.state
        const tenantTop = [
            {
                title: '姓名',
                dataIndex: '姓名',
                key: '姓名',
            },
            {
                title: '关系',
                dataIndex: '关系',
                key: '关系',
            },
            {
                title: '身份证号',
                dataIndex: '身份证号',
                key: '身份证号',
            }
        ]
        const tenantFoot = []
        for (let index = 0; index < tenantLists.length; index++) {
            const element = tenantLists[index];
            tenantFoot.push({
                key: index,
                姓名: element.tenantName,
                关系: element.relation,
                身份证号: element.cardNo
            })
        }
        return (
            <div>
                {loading ?
                    <Spin /> :
                    <Row gutter={[16, 40]}>
                        <Col>
                            <div>
                                <ArrowLeftOutlined style={{ fontSize: '20px' }} onClick={() => { this.changeSon() }} />
                                <h3 style={{ color: "#666", display: 'inline-block', marginLeft: '10px' }}>合同详情</h3>
                            </div>
                        </Col>
                        <Col span={24}>
                            <Descriptions title="房屋信息">
                                <Descriptions.Item label="房号">{houseList[0].houseNo}</Descriptions.Item>
                                <Descriptions.Item label="房型">{houseList[0].roomType}</Descriptions.Item>
                                <Descriptions.Item label="层号">{houseList[0].buildingFloor}</Descriptions.Item>
                                <Descriptions.Item label="楼号">{houseList[0].buildingNo}</Descriptions.Item>
                                <Descriptions.Item label="项目名称">{houseList[0].projectName || 0}</Descriptions.Item>
                                <Descriptions.Item label="面积">{houseList[0].area}</Descriptions.Item>
                                <Descriptions.Item label="朝向">{houseList[0].towards}</Descriptions.Item>
                                <Descriptions.Item label="室号">{houseList[0].roomNo}</Descriptions.Item>
                                <Descriptions.Item label="房屋ID">{houseList[0].houseId}</Descriptions.Item>
                                <Descriptions.Item label="租金">{houseList[0].actualRent}</Descriptions.Item>
                            </Descriptions>
                        </Col>
                        {contractList.contractAttribute == '01' ?
                            <Col span={24}>
                                <Descriptions title="承租人信息">
                                    <Descriptions.Item label="租客姓名">{tenantList.tenantName}</Descriptions.Item>
                                    <Descriptions.Item label="联系电话">{tenantList.tenantContactTel}</Descriptions.Item>
                                    <Descriptions.Item label="证件号码">{tenantList.cardNo}</Descriptions.Item>
                                </Descriptions>
                            </Col> : null
                        }
                        {contractList.contractAttribute == '02' ?
                            <Col span={24}>
                                <Descriptions title="承租人信息">
                                    <Descriptions.Item label="单位名称">{tenantList.companyName}</Descriptions.Item>
                                    <Descriptions.Item label="营业执照号码">{tenantList.companyYyzz}</Descriptions.Item>
                                    <Descriptions.Item label="法定代表人">{tenantList.companyLegallyContact}</Descriptions.Item>
                                    <Descriptions.Item label="联系电话（法定代表人）">{tenantList.companyLegallyContactTel}</Descriptions.Item>
                                    <Descriptions.Item label="委托代理人">{tenantList.companyProxyContact}</Descriptions.Item>
                                    <Descriptions.Item label="联系电话（委托代理人）">{tenantList.companyProxyContactTel}</Descriptions.Item>
                                </Descriptions>
                            </Col> : null
                        }
                        <Col span={24}>
                            <Descriptions title="合同信息">
                                <Descriptions.Item label="租赁时间">{moment(contractList.contractStartDate).format('YYYY-MM-DD')} 至 {moment(contractList.contractEndDate).format('YYYY-MM-DD')}</Descriptions.Item>
                                <Descriptions.Item label="免　　租">{contractList.noPayTime == '0' ? '无' : contractList.noPayTime + '个月'}</Descriptions.Item>
                                <Descriptions.Item label="租赁保证金">{contractList.fukuanType.split('-')[1]}个月</Descriptions.Item>
                                {contractList.fukuanType.split('-')[0] == '1' ?
                                    <Descriptions.Item label="付款周期">{contractList.fukuanType.split('-')[0] == '1'}月付</Descriptions.Item> :
                                    null
                                }
                                {contractList.fukuanType.split('-')[0] == '3' ?
                                    <Descriptions.Item label="付款周期">{contractList.fukuanType.split('-')[0] == '1'}季付</Descriptions.Item> :
                                    null
                                }
                                {contractList.fukuanType.split('-')[0] == '6' ?
                                    <Descriptions.Item label="付款周期">{contractList.fukuanType.split('-')[0] == '1'}半年付</Descriptions.Item> :
                                    null
                                }
                                {contractList.fukuanType.split('-')[0] == '12' ?
                                    <Descriptions.Item label="付款周期">{contractList.fukuanType.split('-')[0] == '1'}年付</Descriptions.Item> :
                                    null
                                }
                                <Descriptions.Item label="收款日期">{contractList.shouZuShiJianType}{contractList.shouZuShiJianDesc}天</Descriptions.Item>
                                <Descriptions.Item label="缴费方式">{contractList.jiaofeiType}</Descriptions.Item>
                                {contractList.jiaofeiType == '银行代扣' ?
                                    <Descriptions.Item label="扣款户名">{contractList.account}</Descriptions.Item> :
                                    null
                                }
                                {contractList.jiaofeiType == '银行代扣' ?
                                    <Descriptions.Item label="开户行">{contractList.bank}</Descriptions.Item> :
                                    null
                                }
                                {contractList.jiaofeiType == '银行代扣' ?
                                    <Descriptions.Item label="扣款账号">{contractList.bankAccount}</Descriptions.Item> :
                                    null
                                }
                            </Descriptions>
                        </Col>
                        <Col span={24}>
                            {billItemList.length > '0' ?
                                <Descriptions title="杂费">
                                    {billItemList[0].itemCategory == '1' ?
                                        <Descriptions.Item>一次性费用</Descriptions.Item> :
                                        null
                                    }
                                    {billItemList[0].itemCategory == '2' ?
                                        <Descriptions.Item>周期性费用</Descriptions.Item> :
                                        null
                                    }
                                    {billItemList[0].itemCategory == '3' ?
                                        <Descriptions.Item>租赁保证金</Descriptions.Item> :
                                        null
                                    }
                                    <Descriptions.Item>{billItemList[0].itemName}</Descriptions.Item>
                                    <Descriptions.Item>{billItemList[0].billAmount}</Descriptions.Item>
                                </Descriptions> :
                                null}
                        </Col>
                        <Col span={24} >
                            <h4 style={{ color: 'rgba(0,0,0,0.85)', fontSize: '16px', fontWeight: 'bold' }}>居住使用人</h4>
                            {/* style={{marginLeft:'-20px',width:'200px'}} */}
                            <Table columns={tenantTop} dataSource={tenantFoot} pagination={false} bordered={true} style={{ margin: '0 -23px', }} />
                        </Col>
                    </Row>
                }
            </div>
        )
    }
    changeSon = () => {
        this.props.getChangeSon('0')
    }
}
// 引入userLoginInfo
const mapStateToProps = (state) => {
    return {
        userLoginInfo: state.userLoginInfo,
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(ContractInfo)